"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContextWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _contexts = require("../contexts");
var _propTypes = require("prop-types");
var ContextWrapper = exports.ContextWrapper = function ContextWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_contexts.AppContext.Provider, {
    value: {
      isStudioLite: true
    }
  }, children);
};
ContextWrapper.propTypes = {
  children: _propTypes.element
};